import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import {
  IOperatorPilot,
  IOperatorPilotForm,
} from 'src/models/operator-pilot.model';
import { useOperatorPilotContext } from 'src/contexts/operator-pilot.context';
import Lang from 'src/libraries/language';
import { getOperatorPilotStatus } from 'src/selectors/operator-pilot.selector';
import { actionTypes } from 'src/ducks/operator-pilot.duck';
import OperatorPilotsForm from '../operator-pilot-relationship-form/operator-pilot-relationship-form.component';
import style from '../operator-pilot-relationship-list/operator-pilot-relationship-list.module.scss';

type IProp = {
  data: IOperatorPilot;
};

const OperatorPilotsEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useOperatorPilotContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues = {
    operatorId: 0,
    pilotId: 0,
    opId: 0,
  };

  if (data) {
    defaultValues = {
      opId: data.opId,
      operatorId:
        data.Operator && data.Operator.operatorId
          ? data.Operator.operatorId
          : 0,
      pilotId: data.Pilot && data.Pilot.pilotId ? data.Pilot.pilotId : 0,
    };
  }

  const editStatus = getOperatorPilotStatus(
    state,
    actionTypes.OPERATOR_PILOT_UPDATE
  );

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IOperatorPilotForm = {
        operatorId: value.operatorId,
        pilotId: value.pilotId,
      };
      const response = await actions.updatePUT(value.opId, formData);
      if (!response.error) {
        ToastSuccess(Lang.MSG_OPERATOR_PILOT_EDIT_SUCCESS);
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_MODIFY_OPERATOR_PILOT}
      content={
        <div className={style.content}>
          <OperatorPilotsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorPilotsEdit;
